import qs from 'qs';
const AskPost = (ajaxinstance) => {
    const customer = {}
    //获取该会议报名字段
    customer.getRegisterField = (meetid) => {
        return ajaxinstance.post('index/meeting/getMeetingRegisterField',qs.stringify({
          meetid
        }));
      }
    //提交报名
    customer.ApplyRegister = (meetid,data) => {
        return ajaxinstance.post('index/users/apply',qs.stringify({
          meetid,...data
        }));
      }
    //获取会议首页
    customer.getMeetingIndex = (meetid) => {
        return ajaxinstance.post('index/home/index',qs.stringify({
          meetid
        }));
      }
    //获取会议详情
    customer.getMeetingInfo = (meetid) => {
      return ajaxinstance.post('index/meeting/index',qs.stringify({
        meetid
      }));
    }
    //获取用户信息
    customer.getUserInfo = (meetid) => {
      return ajaxinstance.post('index/users/getUserinfo',qs.stringify({
        meetid
      }));
    }
    //获取用户信息
    customer.updateUserInfo = (meetid,option,uid) => {
      return ajaxinstance.post('index/users/update',qs.stringify({
        meetid,...option,uid
      }));
    }
    //获取绑定用户验证码
    customer.getRegisterCode = (meetid,mobile) => {
      return ajaxinstance.post('index/users/getCode',qs.stringify({
        meetid,mobile
      }));
    }
    //获取绑定用户验证码
    customer.BindWechat = (meetid,mobile,code) => {
      return ajaxinstance.post('index/users/bindMeeting',qs.stringify({
        meetid,mobile,code
      }));
    }
    //获取微信授权地址
    customer.getWxAuth = (url) => {
      return ajaxinstance.post('index/weixin/authurl',qs.stringify({
        url
      }));
    }
    //获取会收费金额及用户付费情况
    customer.getMeetingPay = (meetid) => {
      return ajaxinstance.post('index/Wxpay/natvie',qs.stringify({
        meetid
      }));
    }
    //获取微信支付配置
    customer.getWxPayConfig = (meetid) => {
      return ajaxinstance.post('index/Wxpay/index',qs.stringify({
        meetid
      }));
    }
    //获取个人中心信息
    customer.getUserInfoIndex = (meetid) => {
      return ajaxinstance.post('index/users/index',qs.stringify({
        meetid
      }));
    }
    //判断是否注册
    customer.getIsApply = (meetid) => {
      return ajaxinstance.post('index/users/is_apply',qs.stringify({
        meetid
      }));
    }
    //会议模块列表
    customer.getModelList = (meetid) => {
        return ajaxinstance.post('index/meeting/getModelList',qs.stringify({
            meetid
        }));
    }
    //会议模块详情
    customer.getModelDetail = (id) => {
        return ajaxinstance.post('index/meeting/getModelDetail',qs.stringify({
            id
        }));
    }
    //会议模块详情
    customer.getModelInfo = (id) => {
        return ajaxinstance.post('index/meeting/getModelInfo',qs.stringify({
            id
        }));
    }
    //获取微信分享
    customer.getShare = (url) => {
        return ajaxinstance.post('index/weixin/getshare',qs.stringify({
            url
        }));
    }
    //获取分享参数
    customer.getMeetingShare = (meetid) => {
        return ajaxinstance.post('index/meeting/getShare',qs.stringify({
            meetid
        }));
    };
    //会场签到
    customer.setUserCheckIn = (meetid,mpid,str) => {
        return ajaxinstance.post('index/users/CheckIn',qs.stringify({
            meetid,mpid,str
        }));
    };

    // 酒店列表
    customer.getHotelList = (params) => {
      return ajaxinstance.post('index/meeting/getHotelList',qs.stringify(params));
    }
    // 酒店房间列表
    customer.getHotelRoomList = (params) => {
      return ajaxinstance.post('index/meeting/getHotelRoomList',qs.stringify(params));
    }
    // 选择酒店（添加/编辑）
    customer.choiceHotel = (params) => {
      return ajaxinstance.post('index/meeting/choiceHotel',qs.stringify(params));
    }
    // 选择接送机
    customer.choiceGivePlain = (params) => {
      return ajaxinstance.post('index/meeting/choiceGivePlain',qs.stringify(params));
    }
    // 开关列表
    customer.getMeetingShowSetList = (params) => {
      return ajaxinstance.post('index/meeting/getMeetingShowSetList',qs.stringify(params));
    }
    // 获取最后时间
    customer.getLastTime = (params) => {
      return ajaxinstance.post('index/meeting/getLastTime',qs.stringify(params));
    }
    // 注册表单开启与用户是否提交注册表单
    customer.getRegister = (params) => {
      return ajaxinstance.post('index/meeting/getRegister',qs.stringify(params));
    }
    // 
    customer.showButton = (params) => {
      return ajaxinstance.post('index/meeting/showButton',qs.stringify(params));
    }
    // 获取省份
    customer.getProvince = (params) => {
      return ajaxinstance.post('/api/api/getProvince',qs.stringify(params));
    }
    // 获取城市
    customer.getCity = (params) => {
      return ajaxinstance.post('/api/api/getCity',qs.stringify(params));
    }
    // 获取市下的机场
    customer.getTrain = (params) => {
      return ajaxinstance.post('/api/api/getTrain',qs.stringify(params));
    }
    // 获取市下的火车站
    customer.getPlain = (params) => {
      return ajaxinstance.post('/api/api/getPlain',qs.stringify(params));
    }
    
    // 获取多级联动地址
    customer.getArea = (params) => {
      return ajaxinstance.post('/api/api/getArea',qs.stringify(params));
    }
    //获取医院地址
    customer.getHospital = (params) => {
      return ajaxinstance.post('/api/api/getHospital',qs.stringify(params));
    }
    
    //获取学科专业
    customer.getSubjectSpecialty = (params) => {
      return ajaxinstance.post('/api/api/getSubjectSpecialty',qs.stringify(params));
    }
    
    //获取学历
    customer.getEducation = (params) => {
      return ajaxinstance.post('/api/api/getEducation',qs.stringify(params));
    }
    
    //获取职称
    customer.getTechnical = (params) => {
      return ajaxinstance.post('/api/api/getTechnical',qs.stringify(params));
    }
    
    //行程更新/添加
    customer.choiceJourney = (params) => {
      return ajaxinstance.post('/index/meeting/choiceJourney',qs.stringify(params));
    }
    
    //会议总览
    customer.pandect = (params) => {
      return ajaxinstance.post('/open/meeting/pandect',qs.stringify(params));
    }
    
    // 表单相关
    customer.sendVerificationCode = (params) => {
      return ajaxinstance.post('/index/meeting/sendVerificationCode',qs.stringify(params));
    }
    // 表单相关
    customer.formRegisterSubmit = (params) => {
      return ajaxinstance.post('/index/meeting/formRegisterSubmit',qs.stringify(params));
    }
    // 表单相关
    customer.getMeetRegister = (params) => {
      return ajaxinstance.post('/index/meeting/getMeetRegister',qs.stringify(params));
    }
    // 表单相关
    customer.formRegisterInfo = (params) => {
      return ajaxinstance.post('/index/meeting/formRegisterInfo',qs.stringify(params));
    }
    // 表单相关
    customer.getAreaCode = (params) => {
      return ajaxinstance.post('/api/api/getAreaCode',qs.stringify(params));
    }

    // 获取用户信息
    customer.getUserinfo = (params) => {
      return ajaxinstance.post('/index/users/getUserinfo',qs.stringify(params));
    }
    // 获取我的详情
    customer.userInfo = (params) => {
      return ajaxinstance.post('/index/meeting/userInfo',qs.stringify(params));
    }
    
    // 获取我的酒店
    customer.myHotel = (params) => {
      return ajaxinstance.post('/index/meeting/myHotel',qs.stringify(params));
    }
    
    // 获取我的酒店
    customer.myHotelInfo = (params) => {
      return ajaxinstance.post('/index/meeting/myHotelInfo',qs.stringify(params));
    }
    
    // 获取我的酒店
    customer.myPlain = (params) => {
      return ajaxinstance.post('/index/meeting/myPlain',qs.stringify(params));
    }
    
    // 获取我的酒店
    customer.myPlainInfo = (params) => {
      return ajaxinstance.post('/index/meeting/myPlainInfo',qs.stringify(params));
    }
    // 获取我的酒店
    customer.myJourney = (params) => {
      return ajaxinstance.post('/index/meeting/myJourney',qs.stringify(params));
    }
    // 获取我的酒店
    customer.myJourneyInfo = (params) => {
      return ajaxinstance.post('/index/meeting/myJourneyInfo',qs.stringify(params));
    }
    // 大屏广告
    
    customer.mobileBigScreenAd = (params) => {
      return ajaxinstance.post('/index/meeting/mobileBigScreenAd',qs.stringify(params));
    }

    customer.getLiveLink = (params) => {
      return ajaxinstance.post('/index/meeting/getLiveLink',qs.stringify(params));
    } 
    
    customer.getUserAreaCode = (params) => {
      return ajaxinstance.post('/index/meeting/getUserAreaCode',qs.stringify(params));
    } 
  
    customer.getUserInfo = (params) => {
      return ajaxinstance.post('/index/meeting/getUserInfo',qs.stringify(params));
    } 
    
    customer.getTypeShowButton = (params) => {
      return ajaxinstance.post('/index/meeting/getTypeShowButton',qs.stringify(params));
    } 
    
    customer.myMeetingList = (params) => {
      return ajaxinstance.post('/index/meeting/myMeetingList',qs.stringify(params));
    } 
    
    customer.getPayData = (params) => {
      return ajaxinstance.post('/index/meeting/getPayData',qs.stringify(params));
    } 

    customer.native = (params) => {
      return ajaxinstance.post('/api/MeetingPay/native',qs.stringify(params));
    } 
    
    customer.jsapi = (params) => {
      return ajaxinstance.post('/api/MeetingPay/jsApiPay',qs.stringify(params));
    } 
    
    customer.orderQuery = (params) => {
      return ajaxinstance.post('/api/MeetingPay/orderQuery',qs.stringify(params));
    } 
    
    customer.getUnUserInfo = (params) => {
      return ajaxinstance.post('/index/meeting/getUnUserInfo',qs.stringify(params));
    } 
  
    customer.getButtonImg = (params) => {
      return ajaxinstance.post('/index/meetingany/getButtonImg',qs.stringify(params));
    } 
    
    return customer
  }

  export default AskPost
